module.exports = __webpack_public_path__ + "img/shape3.3b4d487b.png";